var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.7143 10.2857H10.2857V16.7143C10.2857 17.4214 9.70714 18 9 18C8.29286 18 7.71429 17.4214 7.71429 16.7143V10.2857H1.28571C0.578571 10.2857 0 9.70714 0 9C0 8.29286 0.578571 7.71429 1.28571 7.71429H7.71429V1.28571C7.71429 0.578571 8.29286 0 9 0C9.70714 0 10.2857 0.578571 10.2857 1.28571V7.71429H16.7143C17.4214 7.71429 18 8.29286 18 9C18 9.70714 17.4214 10.2857 16.7143 10.2857Z",
  fill: "currentColor"
})));
export default SvgPlus;